import { SUBJECT_LABEL, subjectSchema } from '@platform/schema/content';

import type { Option } from './FilterSelect';
import type { Subject } from '@platform/schema/content';

/**
 * How the console spells a topic — EXPL-05.
 *
 * `SUBJECT_LABEL` in `packages/schema` is the one spelling, shared with the
 * Explore screen, and this is the one adapter around it. Four screens wanted the
 * same map and wrote it three ways, which is how two filters over one enum end
 * up disagreeing about whether a topic is `FINANCE` or Finance.
 */
export const subjectLabel = (subject: Subject): string =>
  SUBJECT_LABEL[subject];

/** The topics as a filter offers them. Built once: the list is fixed. */
export const SUBJECT_OPTIONS: Option[] = subjectSchema.options.map((value) => ({
  value,
  label: SUBJECT_LABEL[value],
}));
